import React, { useEffect, useState  } from "react";
import { useHistory } from "react-router-dom";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
// import '../../src/public/assets/css/animate.css';
// import '../../src/public/assets/css/bootstrap.min.css';
// import '../../src/public/assets/css/font-awesome.min.css';
// import '../../src/public/assets/css/style.css';

const ProductImage = () => {
  const { id, name } = useParams();
  const [ProductImages, setProductImages] = useState([]);
  const [sortBy, setSortBy] = useState("title-ascending");
  const [sortedProducts, setSortedProducts] = useState([]);
  const [activeView, setActiveView] = useState("grid");
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const CUSTOM_CATEGORY_ORDER = [
    "Melamine Crockery",
    "Porcelain Crockery",
    "Fine Tableware",
    "Acrylic Crockery",
  ];

  // Inside ProductImage.js
const history = useHistory(); // Make sure you have history from react-router-dom

  // const fetchProductImages = () => {
  //   axios
  //     .post(
  //       "https://sachiproduct-backend.theaditech.in/api/product_image/get",
  //       { product_id: id },
  //     ) 
  //     //👈 your API endpoint
  //      .then((response) => {
  //        if (response.data.product.length > 0) {
  //          setProductImages(response.data.product); // Store product data
  //          const sorted = [...response.data.product].sort((a, b) =>
  //            a.product_image_name.localeCompare(b.product_image_name)
  //          );
  //         setSortedProducts(sorted);
  //        }
  //     })
    
  //     .catch((err) => {});
  // };

  const fetchProductImages = () => {
 axios.post(`${BASE_URL}/api/category_wise_product`, { category_id: id })
  .then((response) => {
    const products = response.data.product;

    if (products && products.length > 0) {
      setProductImages(products);
      // ... your existing sorting logic
    } else {
      // 🔥 THIS IS THE KEY: If no products, go to the catalogue page
      // This will match your Route: /product_catalogue/5/Acrylic%20Crockery
      history.replace(`/product_catalogue/${id}/${name}`);
    }
  })
    .catch((err) => {
      console.error("API Error:", err);
      // Fallback redirect
      history.push(`/product_catalogue/${id}/${name}`);
    });
};

  useEffect(() => {
    fetchProductImages();
  }, []);

  const handleSortChange = (e) => {
    const value = e.target.value;
    setSortBy(value);
    let sorted = [...ProductImages];
    switch (sortBy) {
      case "title-descending":
        sorted.sort((a, b) =>
          a.product_image_name.localeCompare(b.product_image_name),
        );
        break;
      case "title-ascending":
        sorted.sort((a, b) =>
          b.product_image_name.localeCompare(a.product_image_name),
        );
        break;
      default:
        break;
    }
    setSortedProducts(sorted);
  };


  return (
    <main className="main-content site-wrapper-reveal">
      <section
        className="page-content-area "
        data-bg-img="assets/img/photos/bg-page-title.webp"
        style={{
          backgroundImage: `url("../../assets/img/product_img_cover.jpg")`,
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-title-content text-center">
                <h2 className="title">Product Images</h2>
                <div className="bread-crumbs">
                  <Link to="/">
                    Home<span className="breadcrumb-sep">/</span>
                  </Link>
                  <span className="active">Product Images</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="product-area featured-product-area"
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-lg-6 m-auto">
              <div className="section-title text-center">
                <h2 className="title">{name}</h2>
              </div>
            </div>
            <div className="col-12">
              <div className="shop-topbar-wrapper">
                <div className="collection-shorting">
                  <div className="shop-topbar-left">
                    <div className="view-mode">
                      <nav>
                        <div
                          className="nav nav-tabs"
                          id="nav-tab"
                          role="tablist"
                        >
                          <button
                            className={`nav-link ${
                              activeView === "grid" ? "active" : ""
                            }`}
                            id="nav-grid-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#nav-grid"
                            type="button"
                            role="tab"
                            aria-controls="nav-grid"
                            onClick={() => setActiveView("grid")}
                          >
                            <i className="fa fa-th"></i>
                          </button>
                          <button
                            className={`nav-link ${
                              activeView === "list" ? "active" : ""
                            }`}
                            id="nav-list-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#nav-list"
                            type="button"
                            role="tab"
                            aria-controls="nav-list"
                            onClick={() => setActiveView("list")}
                          >
                            <i className="fa fa-list-ul"></i>
                          </button>
                        </div>
                      </nav>
                    </div>
                    <p>
                      {" "}
                      Showing 1 - {sortedProducts.length} of{" "}
                      {ProductImages.length} result
                    </p>
                  </div>
                  <div className="product-sorting-wrapper">
                    <div className="product-show">
                      <label for="SortBy">Sort by</label>
                      <select
                        className="form-select"
                        id="SortBy"
                        value={sortBy}
                        onChange={handleSortChange}
                      >
                        <option value="title-ascending" selected>
                          Alphabetically, A-Z
                        </option>
                        <option value="title-descending">
                          Alphabetically, Z-A
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {activeView === "grid" ? (
            <div className="row">
              {sortedProducts.map((element) => {
                return (
                  <div
                    className="col-md-6 col-xl-4"
                    key={element.product_image_id}
                  >
                    <div className="product-item">
                      <div className="product-thumb">
                        <Link
                          to={`/product_detail/${element.product_image_id}`}
                        >
                          <img
                            src={`${BASE_URL}/${element.product_image}`}
                            alt={element.product_image_name}
                            className="zoom-box product-img product-category-img"
                          />
                        </Link>
                      </div>
                      <div className="product-info">
                        <h4 className="sub_title">
                          <Link
                            to={`/product_detail/${element.product_image_id}`}
                          >
                            {element.product_image_name}
                          </Link>
                        </h4>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            // ✅ LIST VIEW
            <div className="list-view">
              {sortedProducts.map((element) => {
                return (
                  <div className="product-item d-flex align-items-center border p-3 mb-3">
                    <div
                      className="product-thumb"
                      style={{ marginRight: "3rem" }}
                    >
                      <Link to={`/product_detail/${element.product_image_id}`}>
                        <img
                          src={`${BASE_URL}/${element.product_image}`}
                          alt="Alan-Shop"
                          className="product-list-img"
                        />
                      </Link>
                    </div>
                    <div className="product-info">
                      <h4 className="title">
                        <Link
                          to={`/product_detail/${element.product_image_id}`}
                        >
                          {element.product_image_name}
                        </Link>
                      </h4>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </main>
  );
};
export default ProductImage;
